import type {
    ContentStackEntryDataProps,
    TextWithImages,
} from '@/types/contentStack';

export function getKeyValue(
    key: string,
    entry: ContentStackEntryDataProps,
): string {
    return entry.key_value.find(item => item.key === key)?.value || '';
}

export const getImagesData = (
    composableWindow: ContentStackEntryDataProps['composable_window'],
    imageDevKey: string,
) => {
    const composableWindowItem = composableWindow.find(
        item => item?.text_with_images?.development_key === imageDevKey,
    );

    return composableWindowItem?.text_with_images;
};

export const getImageUrl = (key: string, imagesData?: TextWithImages) => {
    const imageInclusion = imagesData?.image_inclusion;
    const imageData = imageInclusion?.find(item => item?.image_key === key);
    return imageData?.image_picker[0]?.url;
};

export { findAll } from './findAll';
export { findAllFancy } from './findAllFancy';
export { findAllWhere } from './findAllWhere';
export { findAllWhereRegex } from './findAllWhereRegex';
export { findByContentType } from './findByContentType';
export { findByEntryId } from './findByEntryId';
export { findOne } from './findOne';
export { findOneWhere } from './findOneWhere';
export { findOneWithArrayValues } from './findOneWithArrayValues';
export { getConfigurationByTitle } from './getConfigurationByTitle';
export { getConfigurationPropertiesByDeveloperKey } from './getConfigurationPropertiesByDeveloperKey';
export { getConfigurationSettingByDeveloperKey } from './getConfigurationSettingByDeveloperKey';
